import React from 'react';
import { Link } from 'react-router-dom';

const RankOrRatingDisplay = ({ selectCategory, agentDetails, language }) => {
    if (selectCategory?.access_name === 'Farmer' || selectCategory?.access_name === 'Others' || selectCategory?.amIAssigne) {
        return null;
    }

    return (
        <>
            {selectCategory?.access_name === 'Agent' ? (
                <p>
                    <i className='bi bi-award-fill me-2 kg-warning'></i>
                    <span className='fw-bold'> Rank : </span>
                    Farmer - {agentDetails?.farmerRank ?? 0} |
                    Dealer - {agentDetails?.onboardingRank ?? 0}
                </p>
            ) : (
                <div className='d-flex gap-1'>
                    <Link to={'/reviews'}>
                        <i className='bi bi-star-fill me-2 kg-warning'></i>
                        <span className='fw-bold'>{selectCategory["rating"] ?? 0}</span>
                    </Link>
                    <i className="bi bi-dot"></i>
                    <span><b> {selectCategory["plan_listing_remaining"]} </b> {language("label.remaining_listing")}</span>
                    <i className="bi bi-dot"></i>
                    {(selectCategory?.access_name === 'Dealer' || selectCategory?.access_name === 'Service Provider') && ( <><Link className='link kg-dark-gray'>Write a review</Link></>)}
                </div>
            )}
        </>
    );
};

export default RankOrRatingDisplay;